import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box, Container, Divider, Stack, Typography } from "@mui/material";
import { isArray, isEmpty } from "lodash";
import { FC, Fragment } from "react";
import { AccordionFooter as Accordion } from "../../AccordionFooter";
import { WebShopIcon } from "../../WebShopIcon";
import { FooterProps } from "../lib/type";
import { FooterTextList } from "./FooterSectionList";

export const Footer: FC<FooterProps> = ({ style, sections, copyright }) => {
  return (
    <Box
      component={"footer"}
      className={cn(
        "bg-dark-blue py-[32px] max-md:pt-4",
        style?.background,
        style?.boxShadow,
        style?.padding,
      )}
    >
      <Container maxWidth={"lg"} className={"flex flex-col"}>
        <Stack
          component={"nav"}
          className={
            "flex flex-row items-baseline justify-between max-md:flex-col"
          }
        >
          {isArray(sections) &&
            sections.map(({ name, links }) => {
              return (
                <Fragment key={name}>
                  <Accordion
                    className={"w-full bg-transparent md:hidden"}
                    summaryProps={{
                      expandIcon: (
                        <WebShopIcon name={"arrowDown"} fill={"var(--white)"} />
                      ),
                      className: "px-0",
                    }}
                    detailsProps={{ className: "px-0 py-0" }}
                    summaryChildren={
                      <Typography component={"h3"} className={"text-white"}>
                        {name}
                      </Typography>
                    }
                    detailsChildren={
                      isArray(sections) ? (
                        <FooterTextList links={links} />
                      ) : null
                    }
                  />
                  <Stack className={"flex flex-col gap-2 max-md:hidden"}>
                    {name && (
                      <Typography
                        component={"h3"}
                        className={"text-white opacity-60"}
                      >
                        {name}
                      </Typography>
                    )}
                    {isArray(sections) ? (
                      <FooterTextList links={links} />
                    ) : null}
                  </Stack>
                </Fragment>
              );
            })}
        </Stack>
        <Divider className={"mb-8 mt-8 bg-cold-blue"} />
        {!isEmpty(copyright) && (
          <Stack component={"section"}>
            <Typography className={"text-white opacity-60"}>
              {copyright}
            </Typography>
          </Stack>
        )}
      </Container>
    </Box>
  );
};
